import { Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Protected from './Protected';
import SignIn from './components/Layout/Login';
import { routes } from './AppRoutes';
import PDFViewer from './components/CommonComponents/PDFViewer';
import { useSelector } from 'react-redux';
import ForgotPassword from './components/Layout/ForgotPassword';

export  const App = () => {
    const { lang } = useSelector(state => state.lang)
    return (
        <Routes>
            <Route path='/Login' element={<SignIn />} />
            <Route path='/' element={<SignIn />} />
            <Route path='/PDFViewer' element={<PDFViewer />} />
            <Route path='/ForgotPassword' element={<ForgotPassword />} />
            <Route path='' element={<SignIn />} />
            {routes.map((item, index) =>
                <Route path={`/${item.path}`} key={`menus${index}`} element={<Protected Component={item.component} PageUrl={item.path} />} />
            )}
        </Routes>
    );
}
